var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"product-credit"},[_c('a',{staticClass:"flex justify-center items-center",attrs:{"href":"https://dolyame.ru/","rel":"nofollow","target":"_blank"}},[_c('span',{staticClass:"icon dolyame mr-2"}),_vm._v(" "),_c('span',[_vm._v("или 4 платежа по "),_c('span',[_vm._v(_vm._s(_vm.paymentPartPrice))]),_vm._v("  ₽")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }